import React, { lazy, Suspense } from 'react';
import { WaitlistDialog } from './WaitlistDialog';
import { useDialog } from '../contexts/DialogContext';

const AnimatedBackground = lazy(() => import('./AnimatedBackground').then(m => ({ default: m.AnimatedBackground })));
const InteractiveIcons = lazy(() => import('./InteractiveIcons').then(m => ({ default: m.InteractiveIcons })));

export const Hero: React.FC = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  return (
    <div className="relative pt-20 sm:pt-14" id="hero-section">
      <Suspense fallback={null}>
        <AnimatedBackground />
        <InteractiveIcons />
      </Suspense>
      <div className="py-24 sm:py-32 lg:pb-40">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-4xl font-semibold tracking-tight text-balance sm:text-6xl lg:text-7xl relative z-10" style={{ color: '#241E61' }}>
              The post-purchase operating system for{' '}
              <span className="relative inline-block">
                <span style={{ color: '#241E61' }}>physical products</span>
                <span className="absolute bottom-0 left-0 w-full h-3 -z-10 rounded-full" style={{ background: 'linear-gradient(90deg, #CFF710 0%, #00D084 100%)', opacity: 0.4 }}></span>
              </span>
            </h1>
            <p className="mt-8 text-lg font-medium text-pretty sm:text-xl/8 max-w-2xl mx-auto" style={{ color: '#241E61' }}>
              Give every product a digital identity. Register ownership in 30 seconds. Support customers without phone calls. Manage warranty and returns from one platform.
            </p>

            {/* Proof points */}
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 relative z-10">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold" style={{ color: '#00B37E' }}>35%</div>
                <div className="text-sm font-medium mt-1" style={{ color: '#241E61', opacity: 0.7 }}>Registration rate<br/><span className="text-xs">(vs 10% industry avg)</span></div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-gray-200" />
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold" style={{ color: '#00B37E' }}>80%</div>
                <div className="text-sm font-medium mt-1" style={{ color: '#241E61', opacity: 0.7 }}>Support queries<br/><span className="text-xs">resolved by scan</span></div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-gray-200" />
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold" style={{ color: '#00B37E' }}>30s</div>
                <div className="text-sm font-medium mt-1" style={{ color: '#241E61', opacity: 0.7 }}>To register<br/><span className="text-xs">ownership — no app</span></div>
              </div>
            </div>

            {/* CTAs */}
            <div className="mt-10 flex items-center justify-center gap-x-4 relative z-10">
              <button
                onClick={() => openDialog('waitlist')}
                className="rounded-md px-5 py-3 text-base font-bold shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 transition-all duration-200 transform hover:scale-105 bg-transparent border-none cursor-pointer"
                style={{
                  background: 'linear-gradient(135deg, #CFF710 0%, #00D084 100%)',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  color: '#1a1a1a'
                }}
              >
                Start free
              </button>
            </div>

            {/* Trust line */}
            <p className="mt-8 text-sm relative z-10" style={{ color: '#241E61', opacity: 0.5 }}>
              Trusted by manufacturers of power tools, kitchen equipment, fitness equipment, and HVAC systems
            </p>
          </div>
                
        </div>
      </div>
      <WaitlistDialog 
        isOpen={isDialogOpen('waitlist')} 
        onClose={() => closeDialog()} 
      />
    </div>
  );
}; 